import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "~/components/ui/pageHeader";
import Dashboard from "~/features/projectTop/dashboard";
import { useWebPubSubConnection } from "~/hooks/useWebPubSubConnection";
import { useWebPubSubMessageHandler } from "~/hooks/useWebPubSubMessageHandler";
import type { RootState } from "~/store";
import styles from "./index.module.scss";

export const GenerateStatus = () => {
  const navigate = useNavigate();
  const { projectId } = useParams<{ projectId: string }>();
  const { currentProject, currentUser } = useSelector((state: RootState) => state.auth);

  // WebPubSub接続を確立（Dashboard が client !== null を要求するため）
  useWebPubSubConnection();
  useWebPubSubMessageHandler();

  const organizationId = currentUser?.organization_id;

  const handleBack = () => {
    navigate(`/${organizationId}/project/${projectId}/dashboard`);
  };

  if (!currentProject) {
    return <div>プロジェクトが見つかりません。</div>;
  }

  return (
    <div>
      <div className={styles["breadcrumb"]}>
        <button type="button" className={styles["breadcrumbLink"]} onClick={handleBack}>
          プロジェクトトップ
        </button>
        <span className={styles["breadcrumbSeparator"]}>＞</span>
        <span className={styles["breadcrumbCurrent"]}>生成状況</span>
      </div>
      <PageHeader title={currentProject.name} />
      <Dashboard />
    </div>
  );
};
